import React, { useState } from 'react';
import logo from '../assets/AUSM-LOGO.png';

const FinalPolicyPreview = ({ formData, handleBack, handleSubmit }) => {
    const [agreed, setAgreed] = useState(false);
    const today = new Date().toLocaleDateString('en-GB');
    const guardianAddress = [
        formData?.address?.area?.value ? `منطقة ${formData.address.area.value}` : '',
        formData?.address?.block?.value ? `قطعة ${formData.address.block.value}` : '',
        formData?.address?.street?.value ? `شارع ${formData.address.street.value}` : ''
    ]
        .filter(Boolean)
        .join(' - ');

    return (
        <div className="bg-gray-100 min-h-screen py-10 print:p-0 print:bg-white">
            {/* THE DOCUMENT (PDF Style) */}
            <div className="max-w-[210mm] mx-auto bg-white shadow-2xl p-[15mm] text-right rtl font-sans text-xs leading-relaxed print:shadow-none print:p-0" dir="rtl">
                
                {/* PAGE 1 HEADER */}
                <div className="flex justify-between items-center border-b-2 border-red-800 pb-4 mb-4 ltr" dir="ltr">
                    <div className="flex flex-col items-start">
                        <div className="border-[2px] border-red-800 p-[1px]">
                            <div className="border-[1px] border-red-800 bg-[#b60041] px-4 py-2 flex flex-col items-center justify-center">
                                <div className="h-16 w-16 overflow-hidden flex items-center justify-center">
                                    <img src={logo} alt="AUMS Logo" className="h-full w-auto object-cover object-left" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center flex-1 px-4">
                        <div className="flex flex-col items-center flex-1">
                        <p className="text-[#1e3a8a] font-bold text-2xl mb-1">American University for Medical Sciences</p>
                        <p className="text-[#1e3a8a] font-bold text-1xl mb-1" dir="rtl">الجامعة الامريكية للعلوم الطبيه</p>
                    </div>
                    </div>

                    <div className="flex flex-col gap-2 items-end">
                        <div className="bg-yellow-400 text-black px-4 py-1 font-bold border border-black text-sm w-full text-center">Self-Funded Only</div>
                        <div className="bg-[#f3b08c] text-black px-6 py-2 font-bold border border-black text-xl shadow-md w-full text-center">FORM C</div>
                    </div>
                </div>

                <div className="bg-gray-200 p-2 text-center mb-4 border border-gray-400">
                    <p className="font-bold">إقرار وتعهد بتسديد الرسوم والإلتزام بسياسة الإسترداد في حالة القبول</p>
                    <p className="font-bold">في برنامج بكالوريوس طب الأسنان</p>
                    <p className="font-bold">2026/2027</p>
                </div>

                <p className="text-red-700 underline mb-2 font-bold">أولاً : الرسوم والمبالغ (الغير قابلة للاسترداد) :</p>
                <div className="pr-4 mb-4">
                    <p>1- رسوم التقديم: 20 دينار كويتي (تدفع مرة واحدة)</p>
                    <p>2- رسوم اختبارات القبول: 5 دينار لكل اختبار (تدفع مرة واحدة)</p>
                    <p>3- رسوم التسجيل: 150 دينار كويتي (لكل فصل دراسي) وتخصم من الرسوم الدراسية المدفوعة للفصل الدراسي</p>
                    <p>4- مبلغ حجز المقعد الدراسي: 1500 دينار كويتي (يُسدد مرة واحدة عند القبول، ويُخصم من الرسوم الدراسية للفصل الدراسي الذي تم القبول فيه بالجامعة)</p>
                </div>

                <p className="text-red-700 underline mb-2 font-bold">ثانياً : الرسوم الدراسية:</p>
                <div className="pr-4 mb-4 text-justify">
                    <p>- عند الترشيح للقبول في الجامعة، يلتزم الطالب بسداد مبلغ حجز المقعد الدراسي (غير قابل للاسترداد)، بالإضافة إلى كامل رسوم الفصل الدراسي الذي تم القبول فيه بالجامعة، وذلك قبل إرسال رسالة القبول عبر البريد الإلكتروني. وفي حال عدم الالتزام بالسداد خلال المدة المحددة والمذكورة في البلاغ، يُعدّ الترشيح ملغيًا تلقائيًا دون الحاجة إلى إشعار أو إنذار مسبق.</p>
                    <p>- للفصول الدراسية المتتالية: يجب دفع الرسوم الدراسية لكل فصل دراسي بالكامل خلال ثلاثين يوم من تاريخ ارسال اشعار طلب الدفع لاستكمال التسجيل.</p>
                </div>

                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-[#cceaff] text-black font-bold">
                            <th className="border border-black p-1">الرسوم الدراسية</th>
                            <th className="border border-black p-1">الحد الأدنى لعدد الساعات المعتمدة المطلوبة للتخرج</th>
                            <th className="border border-black p-1">المعدل المطلوب للتخرج</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="font-bold">
                            <td className="border border-black p-1">* 360 دينار كويتي لكل ساعة معتمدة</td>
                            <td className="border border-black p-1">215</td>
                            <td className="border border-black p-1">معدل تراكمي (CGPA) لا يقل عن 2.00</td>
                        </tr>
                    </tbody>
                </table>

                <div className="text-xs mb-4 font-bold">
                    <p>* تحتفظ الجامعة بحقها في تغيير الرسوم الدراسية خلال فترة الدراسة بعد موافقة مجلس الجامعات الخاصة.</p>
                    <p>* في حال تعديل الرسوم الدراسية من قبل مجلس الجامعات الخاصة – سوف يتم تطبيق التعديل على الرسوم الدراسية لجميع الطلاب.</p>
                    <p>* الرسوم الدراسية المذكورة أعلاه لا تشمل رسوم أو تكاليف الكتب والمواد الاستهلاكية والأدوات والخدمات.</p>
                    <p>* إعادة المقررات الدراسية: تطبق الرسوم الدراسية كاملة على المقررات المكررة لأي سبب من الأسباب.</p>
                </div>

                <p className="text-red-700 underline mb-2 font-bold">ثالثاً : الشروط العامة :</p>
                <div className="pr-4 mb-4">
                    <p>- يلتزم الطالب بالتسجيل وفق عدد الساعات المعتمدة المحددة في الخطة الدراسية للبرنامج.</p>
                    <p>- التكاليف الإضافية: جميع المواد والأدوات والأجهزة الاستهلاكية الخاصة باستخدامات الطالب نفسه في المختبرات والعيادات التدريبية خلال فترة الدراسة في الجامعة تكون على نفقة الطالب الخاصة.</p>
                    <p>- تعديلات الرسوم: تحتفظ الجامعة بالحق في تعديل الرسوم بموافقة مجلس الجامعات الخاصة في الكويت ومجلس أمناء الجامعة.</p>
                </div>

                <p className="text-red-700 underline mb-2 font-bold">رابعاً : عدم التزام الطالب بدفع الرسوم الدراسية :</p>
                <div className="pr-4 mb-4">
                    <p>يترتب على عدم دفع الرسوم الدراسية وفقًا للبند الثاني وفي الوقت الزمني المحدد أعلاه إلغاء تسجيل الطالب في الفصل الدراسي الحالي أو القادم لحين سداد المديونية واتخاذ الجامعة الإجراءات القانونية اللازمة.</p>
                </div>

                <p className="text-red-700 underline mb-2 font-bold">خامساً : سياسة الاسترداد :</p>
                <p className="underline mb-1 font-bold">1- القواعد العامة:</p>
                <div className="pr-4 mb-4">
                    <p>- يتم احتساب الرسوم المستردة بناءً على مجمل الرسوم الدراسية المستحقة على الطالب (لا تشمل الرسوم والمبالغ الغير قابلة للاسترداد).</p>
                    <p>- على الطالب الالتزام بسياسة استرداد الرسوم.</p>
                    <p>- تنطبق سياسة الاسترداد على الرسوم الدراسية فقط وأي رسوم أخرى فهي غير قابلة للاسترداد.</p>
                    <p>- الطالب المفصول لأي سبب من الأسباب لا يسترد أي من الرسوم الدراسية أو الإضافية المدفوعة.</p>
                    <p>- في حال إلغاء أو إيقاف البرنامج الدراسي لأي سبب، يحق للطالب استرداد الرسوم الدراسية التي تم سدادها للجامعة عن الفصل الدراسي الذي تم فيه الإلغاء أو الإيقاف فقط، ولا تشمل أي فصول دراسية سابقة.</p>
                    <p>- لا تسترد أي رسوم دراسية لطالب تم إلغاء قيده.</p>
                </div>

                <p className="text-red-700 underline mb-2 font-bold underline-offset-4">2- Course Drop - في حال سحب مقررات لجميع الفصول الدراسية (ماعدا الفصل الصيفي) بعد السنة الدراسية الأولى:</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-[#b3b3b3] text-black font-bold">
                            <th className="border border-black p-1">الفترة الزمنية</th>
                            <th className="border border-black p-1">استرداد الرسوم (فصلي الخريف والربيع)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="font-bold">
                            <td className="border border-black p-1">خلال الأسبوع الأول من الفصل الدراسي</td>
                            <td className="border border-black p-1">استرداد 75% من المقرر المنسحب منه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">خلال الأسبوع الثاني من الفصل الدراسي</td>
                            <td className="border border-black p-1">استرداد 50% من المقرر المنسحب منه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">خلال الأسبوع الثالث من الفصل الدراسي</td>
                            <td className="border border-black p-1">استرداد 25% من المقرر المنسحب منه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">بعد الأسبوع الثالث من الفصل الدراسي</td>
                            <td className="border border-black p-1">لا يُسترد أي مبلغ</td>
                        </tr>
                    </tbody>
                </table>

                <div className="font-bold mb-4">
                    <p>لا يجوز استرداد الرسوم الدراسية في الحالات التالية:</p>
                    <p>أ- سحب مقرر دراسي بعد انتهاء فترة الانسحاب الرسمي المقررة من الجامعة وفق التقويم الأكاديمي للجامعة.</p>
                    <p>ب- الانسحاب بسبب الحصول على إنذار عدم حضور، أو الانسحاب لسبب تأديبي، أو الفصل من الجامعة.</p>
                    <p>ج- تسجيل الطالب في المقررات دون 15 ساعة معتمدة في الفصل الدراسي.</p>
                    <p>د- لا يحق للطالب استرداد أية رسوم نتيجة حذف المواد دون الحد الأدنى (15) وحدة دراسية.</p>
                </div>

                {/* PAGE BREAK FOR PRINT */}
                <div style={{ breakAfter: "page", pageBreakAfter: "always" }}></div>

                <p className="text-red-700 underline mb-2 mt-10 font-bold underline-offset-4">3- سياسة استرداد الرسوم في حال الانسحاب من المقرر الدراسي (الفصل الصيفي)</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-[#b3b3b3] text-black font-bold">
                            <th className="border border-black p-1">الفترة الزمنية</th>
                            <th className="border border-black p-1">استرداد الرسوم (الفصل الدراسي الصيفي)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="font-bold">
                            <td className="border border-black p-1">أول 3 أيام (فترة الإضافة/الإسقاط) من الفصل الدراسي الصيفي</td>
                            <td className="border border-black p-1">استرداد 75% من المقرر المنسحب منه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">اليوم الرابع و الخامس من الفصل الدراسي الصيفي</td>
                            <td className="border border-black p-1">استرداد 50% من المقرر المنسحب منه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">خلال الأسبوع الثاني من الفصل الدراسي الصيفي</td>
                            <td className="border border-black p-1">استرداد 25% من المقرر المنسحب منه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">الأسبوع الثالث من الفصل الدراسي الصيفي وما بعده</td>
                            <td className="border border-black p-1">لا يسترد أي مبلغ</td>
                        </tr>
                    </tbody>
                </table>

                <p className="text-red-700 underline mb-2 font-bold underline-offset-4">4- سياسة استرداد الرسوم في حال الانسحاب من الجامعة</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-[#b3b3b3] text-black font-bold">
                            <th className="border border-black p-1">الفترة الزمنية</th>
                            <th className="border border-black p-1">استرداد الرسوم (فصلي الربيع و الخريف)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="font-bold">
                            <td className="border border-black p-1">خلال الأسبوع الأول (فترة الإضافة/السحب) من الفصل الدراسي</td>
                            <td className="border border-black p-1">استرداد 75% من الرسوم الدراسية للفصل الدراسي المنسحب منه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">خلال الأسبوع الثاني من الفصل الدراسي</td>
                            <td className="border border-black p-1">استرداد 50% من الرسوم الدراسية للفصل الدراسي المنسحب منه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">الأسبوع الثالث من الفصل الدراسي وما بعده</td>
                            <td className="border border-black p-1">لا يسترد أي مبلغ</td>
                        </tr>
                    </tbody>
                </table>

                <p className="text-red-700 underline mb-2 font-bold underline-offset-4">5- سياسة استرداد الرسوم في حال تجميد الفصل الدراسي (وقف القيد):</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-[#b3b3b3] text-black font-bold">
                            <th className="border border-black p-1">الفترة الزمنية</th>
                            <th className="border border-black p-1">استرداد الرسوم (فصلي الربيع و الخريف)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="font-bold">
                            <td className="border border-black p-1">تقديم طلب وقف قيد قبل 10 أيام عمل من أول يوم لبدء الدراسة في الفصل الدراسي</td>
                            <td className="border border-black p-1">استرداد 100% من الرسوم الدراسية للفصل الدراسي المراد إيقافه</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black p-1">تقديم طلب وقف قيد في أي وقت بعد الوقت المحدد أعلاه</td>
                            <td className="border border-black p-1">لا يسترد أي مبلغ و يطالب بدفع الرسوم الدراسية كاملة</td>
                        </tr>
                    </tbody>
                </table>

                <p className="mb-4 font-bold">ملاحظات هامة: بخصوص تعليق التسجيل (وقف القيد الدراسي):</p>
                <div className="pr-4 mb-6 font-bold">
                    <p>- لا يجوز للطالب وقف قيده قبل الانتهاء من السنة الثانية من الدراسة بنجاح.</p>
                    <p>- يجب على الطالب الالتزام بالمواعيد النهائية لوقف القيد بالدراسة المبينة في دليل الطالب وفق الشروط والأحكام ووفق التقويم الأكاديمي للجامعة.</p>
                </div>

                {/* SIGNATURE BLOCK */}
                <div className="pt-4 mt-10 text-xs" dir="rtl">
                    <div className="flex items-center gap-3 mb-4 p-3 border border-dashed border-[#b60041]/40 rounded-md">
                        <input
                            id="final-policy-agree"
                            type="checkbox"
                            checked={agreed}
                            onChange={() => setAgreed(!agreed)}
                            className="w-5 h-5 accent-[#b60041]"
                        />
                        <label htmlFor="final-policy-agree" className="text-sm font-bold cursor-pointer">
                            I agreed to the terms and condition above / أوافق على الشروط والأحكام المذكورة أعلاه
                        </label>
                    </div>

                    {agreed ? (
                        <>
                            <div className="flex items-center gap-2 mb-3">
                                <p className="text-xs font-bold">إقرار بالعلم و الموافقة:</p>
                            </div>

                            <p className="mb-4 text-justify font-bold text-xs">أقر بأنني اطلعت على السياسة المالية أعلاه و أوافق على جميع ما جاء من الشروط و البنود أعلاه والالتزام بها في حال قبولي</p>

                            {/* Student section */}
                            <div className="space-y-3 text-xs mb-8">
                                <div className="flex w-full gap-6">
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">اسم الطالب:</span>
                                        <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs">{formData.arabicFirstName?.value} {formData.arabicMiddleName?.value} {formData.arabicLastName?.value}</span>
                                    </div>
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">الرقم المدني للطالب:</span>
                                        <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs tracking-widest">{formData.civilId?.value}</span>
                                    </div>
                                </div>
                                <div className="flex items-center gap-1 w-full">
                                    <span className="font-bold whitespace-nowrap">البريد الإلكتروني للطالب للتواصل:</span>
                                    <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs">{formData.emailOne?.value}</span>
                                </div>
                                <div className="flex w-full gap-6">
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">توقيع الطالب:</span>
                                        <span className="border-b border-red-500 flex-1 min-h-[1.2em] inline-block"></span>
                                    </div>
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">التاريخ:</span>
                                        <span className="border-b border-red-500 flex-1 min-h-[1.2em] inline-block"></span>
                                    </div>
                                </div>
                            </div>

                            <p className="mb-4 text-justify font-bold text-xs">بصفتي ولي أمر الطالب اعلاه أقر بأنني اطلعت على السياسة المالية أعلاه وأوافق عليها وأتعهد بتسديد الرسوم الدراسية في تواريخ استحقاقها وألتزم باتباع جميع تعليمات وقوانين الجامعة ، وفي حال تغيير أي من البيانات أدناه أتعهد بإبلاغ قسم شؤون الطلبة بالجامعة.</p>

                            {/* Guardian section */}
                            <div className="space-y-3 text-xs">
                                <div className="flex w-full gap-6">
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">إسم ولي الأمر/ المقر:</span>
                                        <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs">{formData.family?.arabicFatherName?.value}</span>
                                    </div>
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">الرقم المدني لولي الأمر:</span>
                                        <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs tracking-widest">{formData.family?.fatherCivilId?.value}</span>
                                    </div>
                                </div>
                                <div className="flex items-center gap-1 w-full">
                                    <span className="font-bold whitespace-nowrap">العنوان:</span>
                                    <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs">{guardianAddress}</span>
                                </div>
                                <div className="flex w-full gap-6">
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">رقم الجوال :</span>
                                        <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs">{formData.family?.fatherMobile?.value}</span>
                                    </div>
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">رقم الهاتف:</span>
                                        <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs">{formData.family?.fatherWorkTel?.value}</span>
                                    </div>
                                </div>
                                <div className="flex items-center gap-1 w-full">
                                    <span className="font-bold whitespace-nowrap">البريد الإلكتروني:</span>
                                    <span className="border-b border-black flex-1 text-center font-bold min-h-[1.2em] text-blue-600 text-xs">{formData.family?.fatherEmail?.value}</span>
                                </div>
                                <div className="flex w-full gap-6">
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">توقيع ولي الأمر:</span>
                                        <span className="border-b border-red-500 flex-1 min-h-[1.2em] inline-block"></span>
                                    </div>
                                    <div className="flex-1 flex items-center gap-1">
                                        <span className="font-bold whitespace-nowrap">التاريخ :</span>
                                        <span className="border-b border-red-500 flex-1 min-h-[1.2em] inline-block"></span>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
            </div>

            {/* DESIGN PATTERN BUTTONS */}
            <div className="max-w-[210mm] mx-auto mt-10 mb-20 flex flex-col print:hidden">
                <div className="w-full h-[1px] bg-[#b60041] mb-6"></div>
                <div className="flex justify-end gap-4">
                    <button 
                        type="button"
                        onClick={handleBack}
                        className="border-[#b60041] border-[1px] text-[#b60041] px-8 py-1 rounded-md font-bold text-sm tracking-wider uppercase hover:bg-[#b60041] hover:text-white transition-all"
                    >
                        BACK
                    </button>
                    <button 
                        type="button"
                        onClick={handleSubmit}
                        disabled={!agreed}
                        className={`px-10 py-1 rounded-md font-bold text-sm tracking-wider uppercase shadow-md transition-all ${
                            agreed
                                ? 'bg-[#b60041] text-white hover:bg-[#8e0032]'
                                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                    >
                        NEXT
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FinalPolicyPreview;
